import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, NavLink, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get, find } from 'lodash';

import { userActions } from '_actions';

// UI Components
import Navbar, { NavHalf, NavOption, NavbarLink } from 'sc-ui/Navbar';
import { Image, Text } from 'sc-ui';
import { Avatar, Badge, Dropdown, Menu, Drawer, Button, Icon } from 'antd';
import { Referrals } from '_components';

// Images
import Logo from 'images/logo.svg';

const propTypes = {
    // Parent Props
    authed: PropTypes.bool,
    user: PropTypes.object
};
const defaultProps = {
    user: {}
};

class Navigation extends React.Component {
    state = {
        currentRoute: 'home',
        refDrawerOpen: false
    };

    setRefDrawerOpen = value => this.setState({ refDrawerOpen: value });
    menuOnClick = ({ item, key, keyPath }) => {
        switch (key) {
            case 'settings':
                this.props.history.push(`/settings`);
                break;
            case 'admin':
                this.props.history.push(`/admin`);
                break;
            case 'referrals':
                break;
            case 'signout':
                this.props.logout();
                break;
            default:
                console.log('default case');
        }
    };

    render() {
        const { history, user } = this.props;
        const live = true;
        const pathname = this.props.location ? this.props.location.pathname : '';
        const refType = get(user, ['referrer_type']) || 'DEFAULT';
        const points = get(user, ['referral_points']) || 0;
        const userPromos = get(user, ['user_promos']);
        const basicReferral = find(userPromos, { promo: { is_basic: true } });
        const numBasicReferrals = get(basicReferral, ['amount_remaining']);

        const referralBadgeNumber = refType === 'AMBASSADOR' ? points : numBasicReferrals;

        return (
            <Navbar>
                {window.matchMedia('(min-width: 960px)').matches && (
                    <NavHalf justify="flex-start" flex="2">
                        <Image
                            size="xlrg"
                            src="https://s3-us-west-2.amazonaws.com/smoothieclub-assets/sc-logo-svg.svg"
                            alt="Smoothie Club"
                            margin="0 40px"
                            onClick={() => this.props.history.push('/home')}
                        />
                        <NavOption
                            routeName="Home"
                            pathName="/home"
                            currPath={pathname}
                            history={history}
                        />
                        <NavOption
                            routeName="About"
                            pathName="/about"
                            currPath={pathname}
                            history={history}
                        />
                        <NavOption
                            routeName="Smoothies"
                            pathName="/smoothies"
                            currPath={pathname}
                            history={history}
                        />
                        {localStorage.getItem('user') && (
                            <NavOption
                                routeName="Next Order"
                                pathName="/order"
                                currPath={pathname}
                                history={history}
                            />
                        )}
                    </NavHalf>
                )}
                {window.matchMedia('(max-width: 960px)').matches && (
                    <React.Fragment>
                        <NavHalf justify="flex-start">
                            <Dropdown
                                overlay={
                                    <Menu>
                                        <Menu.Item key="home">
                                            <NavLink to="/home">Home</NavLink>
                                        </Menu.Item>
                                        <Menu.Item key="about">
                                            <NavLink to="/about">About</NavLink>
                                        </Menu.Item>
                                        <Menu.Item key="smoothies">
                                            <NavLink to="/smoothies">Smoothies</NavLink>
                                        </Menu.Item>
                                        {localStorage.getItem('user') && (
                                            <Menu.Item key="order">
                                                <NavLink to="/order">Next Order</NavLink>
                                            </Menu.Item>
                                        )}
                                    </Menu>
                                }
                                placement="bottomRight"
                                trigger={['click']}
                            >
                                <Button
                                    icon="menu"
                                    size="large"
                                    shape="circle"
                                    style={{ margin: '0 20px' }}
                                />
                            </Dropdown>
                        </NavHalf>
                        <NavHalf justify="center">
                            <Image
                                size="xs"
                                src="https://s3-us-west-2.amazonaws.com/smoothieclub-assets/sc-favicon.svg"
                                alt="Smoothie Club"
                                margin="0 40px"
                                onClick={() => this.props.history.push('/home')}
                            />
                        </NavHalf>
                    </React.Fragment>
                )}
                <NavHalf justify="flex-end">
                    {localStorage.getItem('user') ? (
                        <React.Fragment>
                            <Dropdown
                                overlay={
                                    <Menu onClick={this.menuOnClick}>
                                        <Menu.Item key="settings">Account Settings</Menu.Item>
                                        {localStorage.getItem('perm') >= 5 && (
                                            <Menu.Item key="admin">Admin Panel</Menu.Item>
                                        )}
                                        <Menu.Item
                                            key="referrals"
                                            onClick={() => this.setRefDrawerOpen(true)}
                                        >
                                            Referrals
                                            <Badge
                                                count={referralBadgeNumber}
                                                style={{
                                                    backgroundColor: '#ee207a',
                                                    margin: '0 0 4px 4px'
                                                }}
                                            />
                                        </Menu.Item>
                                        <Menu.Divider />
                                        <Menu.Item key="signout">
                                            <Text color="secondary">Sign Out</Text>
                                        </Menu.Item>
                                    </Menu>
                                }
                                placement="bottomCenter"
                                trigger={['click']}
                            >
                                <Button size="large" shape="circle" style={{ margin: '0 20px' }}>
                                    <Badge
                                        count={referralBadgeNumber}
                                        style={{ backgroundColor: '#ee207a' }}
                                    >
                                        <Icon type="user" style={{ fontSize: '24px' }} />
                                    </Badge>
                                </Button>
                            </Dropdown>
                        </React.Fragment>
                    ) : (
                        <NavOption
                            routeName="Login"
                            pathName="/login"
                            currPath={pathname}
                            history={history}
                            login
                        />
                    )}
                </NavHalf>

                <Referrals
                    user={this.props.user}
                    onClose={() => this.setRefDrawerOpen(false)}
                    visible={this.state.refDrawerOpen}
                />
            </Navbar>
        );
    }
}

Navigation.propTypes = propTypes;
Navigation.defaultProps = defaultProps;

function mapStateToProps(state) {
    const { user } = state.users;
    return {
        user
    };
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            logout: userActions.logout
        },
        dispatch
    );

const ConnectedNavigationWithRouter = withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Navigation)
);

export { ConnectedNavigationWithRouter as Navigation };



// WEBPACK FOOTER //
// ./src/_components/Navigation.jsx